import OrderState from '~/constants/common/OrderState';
import { useIsLoggedIn } from '~/context/common/UserContext';
import { useGetUserPurchase } from '~/context/home/UserPurchaseContext';
import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';
import Hero from './Hero';
import HeroCards from './HeroCards';
import OrderStatusModule from './OrderStatusModule';

export default function HeroSection() {
  const isInPurchaseInProgressExperiment = useIsInExperiment(
    'car-merch-ui-home-purchase-in-progress',
    'treatment'
  );
  const isLoggedIn = useIsLoggedIn();
  const {
    data: { orderState, vehicle },
    isLoaded
  } = useGetUserPurchase();

  const showOrderStatusModule =
    isInPurchaseInProgressExperiment &&
    isLoggedIn &&
    isLoaded &&
    orderState !== OrderState.None &&
    vehicle != null;

  return showOrderStatusModule ? (
    <OrderStatusModule />
  ) : (
    <>
      <Hero />
      <HeroCards />
    </>
  );
}
